import { useTranslation } from 'next-i18next';

import { Box, Flex, Text, VStack } from '@chakra-ui/react';

import { wordPluralisation } from '@nocowanie/common-ui';

import { RatingRate } from '@app/components/molecules/rating-rate';
import { getRatingDescValue } from '@app/helpers';

import { RatingProps } from './rating.props';

export const Rating = ({
    ratingAverage,
    ratingCount,
    ratingDescription,
    hideLabelsOnMobile = false,
    labelProps = {},
    ratingProps = {},
    ...props
}: RatingProps) => {
    const breakOn = 'md';
    const { t } = useTranslation('accommodation');

    const translationOpinionsValue = t('opinions', {
        returnObjects: true,
    }) as Record<string, string>;

    return (
        <Flex
            alignItems={'center'}
            gap={'gutterWidth'}
            textAlign={'right'}
            justifyContent={'end'}
            flexDirection={'row-reverse'}
            data-testid={'rating'}
            {...props}
        >
            <RatingRate ratingAverage={ratingAverage} {...ratingProps} />
            <VStack
                hideBelow={hideLabelsOnMobile ? breakOn : undefined}
                gap={1.5}
                alignItems={hideLabelsOnMobile ? 'flex-end' : 'flex-start'}
                flexWrap={'wrap'}
            >
                <Box
                    fontWeight={'bold'}
                    fontSize={'lg'}
                    lineHeight={1}
                    truncate
                    data-testid="rating-text"
                    {...labelProps}
                >
                    {getRatingDescValue(ratingDescription)}
                </Box>
                <Text
                    as={'span'}
                    fontSize={'sm'}
                    color={'gray.700'}
                    lineHeight={1}
                    data-testid="rating-count"
                >
                    {ratingCount}{' '}
                    {wordPluralisation(
                        ratingCount,
                        translationOpinionsValue.singular,
                        translationOpinionsValue.plural,
                        translationOpinionsValue.genitivePlural,
                    )}
                </Text>
            </VStack>
        </Flex>
    );
};
